import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "hero section" }
const _hoisted_2 = { class: "hero__container" }
const _hoisted_3 = { class: "hero__header" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Grow your ")
const _hoisted_5 = /*#__PURE__*/_createElementVNode("hr", { class: "ruler--white" }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", { class: "hero__text" }, " Incentivize players to join your gaming community across platforms. ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_typing_carousel = _resolveComponent("typing-carousel")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h1", _hoisted_3, [
        _hoisted_4,
        _createVNode(_component_typing_carousel, { values: ['Discord guild', 'Steam group', 'game server', 'community'] })
      ]),
      _hoisted_5,
      _hoisted_6
    ])
  ]))
}